import { PublicPost } from '../models';
import { PostRepository } from '../repositories';

export class GetPublicPostUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(postId: string): Promise<PublicPost | null> {
    return this.postRepository.getPublicById(postId);
  }
}
